/*
[QUICK GUIDANCE]
Use 100s as background fills
Use 200s for interactive elements, chips, tags, etc.
Use 400s - reserved for future use.
Use 500s as text color on white (semantic usage).
Use 500s as icon color on color-100/200 fills.
Avoid using 500s (excl. primary-500s) as element fills. 
 */

export const colors = {
  pinkFlink: {
    100: "#FEECF4",
    200: "#FDD8E9",
    400: "#F97FB5",
    500: "#E81F76",
  },
  nightBlueFlink: {
    500: "#002855",
  },
  purple: {
    100: "#F1ECF9",
    200: "#E5DBF3",
    400: "#AE95DA",
    500: "#7C55C3",
  },
  marine: {
    100: "#E9F3FB",
    200: "#D3E6F7",
    400: "#69AAE4",
    500: "#257FCF",
  },
  veggie: {
    100: "#E8F7F5",
    200: "#D0EFEA",
    400: "#66C8BA",
    500: "#009B7D",
  },
  grey: {
    100: "#F8F8F8",
    150: "#F2F2F2",
    200: "#DEDEDE",
    250: "#D9D9D9", // not included in Figma
    300: "#C4C4C4",
    350: "#ECECEC", // not included in Figma
    400: "#ABABAB",
    450: "#999999",
    500: "#919191",
    600: "#787878",
    650: "#E6E6E6", // not included in Figma
    700: "#5E5E5E",
    800: "#454545",
  },
  orange: {
    100: "#FFF0E0",
    200: "#FFE8D0",
    400: "#FFB063",
    500: "#EC7400",
  },
  red: {
    100: "#FFE0E0",
    400: "#E03030", // not included in Figma
    500: "#CC0000",
  },
  blueFlink: {
    100: "#E6F4FF",
    500: "#0066CC",
    600: "#0099FF",
  },
  black: "#000000",
  white: "#FFFFFF",
  sunny: {
    // not included in Figma
    200: "#FCF6D4",
    400: "#F0D22B",
    500: "#FADD00",
  },
  error: "#D8232A", // not included in Figma
  critical: "#F55B00", // not included in Figma
  lightBlue: "#5AA8EA", // not included in Figma
};
